import { __rest } from "tslib";
import clsx from 'clsx';
import React from 'react';
import CrossIcon from '@cmpkit/icon/lib/glyph/cross';
import { Slot } from '@cmpkit/utils';
import { tagVariants } from './variants';
const Tag = React.forwardRef((props, ref) => {
    const { as: Component = 'div', asChild, variant, className, children, onClose, iconBefore } = props, attributes = __rest(props, ["as", "asChild", "variant", "className", "children", "onClose", "iconBefore"]);
    const classes = clsx(tagVariants({ variant }), className);
    const Comp = asChild ? Slot : Component;
    return (React.createElement(Comp, Object.assign({}, attributes, { className: classes, ref: ref }),
        iconBefore,
        React.createElement("span", { className: 'tag-text' }, children),
        onClose && (React.createElement("button", { className: 'tag-remove ml-1', onClick: onClose },
            React.createElement(CrossIcon, { className: 'size-3' })))));
});
Tag.displayName = 'Tag';
export { Tag };
//# sourceMappingURL=Tag.js.map